import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { ChallengeCard, LoadingChallengeCard } from '@infl-ts/ui-advocate-components';
import { useToggle } from '@infl-ts/util-hooks';
import { DisplayQueryError } from '@infl-ts/util-query-errors';
import { createChallengePlayerLink } from '@infl-ts/util-use-challenge-player';
import { Box, Button, Typography } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import * as A from 'fp-ts/Array';
import { identity, pipe } from 'fp-ts/function';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var RecommendedChallenges = function RecommendedChallenges(_ref) {
  var challenges = _ref.challenges,
      showUnlocked = _ref.showUnlocked,
      handleFetchMore = _ref.handleFetchMore,
      hasMoreToShow = _ref.hasMoreToShow;
  var recommendedChallenges = challenges !== null && challenges !== void 0 ? challenges : [];

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      showingMore = _useToggle2[0],
      showMore = _useToggle2[1].on;

  var location = useLocation();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  if (recommendedChallenges.length === 0) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Box, {
      sx: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: 1
      },
      "data-element": "Box",
      "data-component": "RecommendedChallenges",
      "data-source-file": "recommended-challenges.tsx",
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "h3",
        sx: {
          mb: 3,
          zIndex: function zIndex(t) {
            return t.zIndex._3;
          }
        },
        "data-element": "Typography",
        "data-component": "RecommendedChallenges",
        "data-source-file": "recommended-challenges.tsx",
        children: showUnlocked ? t("You've unlocked new challenges") : t('You might enjoy one of these')
      })
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        maxWidth: 880,
        display: 'flex',
        gap: 2,
        flexWrap: 'wrap',
        justifyContent: 'center',
        width: 1
      },
      "data-element": "Box",
      "data-source-file": "recommended-challenges.tsx",
      children: pipe(recommendedChallenges, showingMore ? identity : A.takeLeft(3), A.map(function (challenge) {
        return challenge && /*#__PURE__*/_jsx(Box, {
          sx: {
            width: function width(t) {
              return {
                lg: "calc(100% / 3 - ".concat(t.spacing(2), ")"),
                md: "calc(100% / 2 - ".concat(t.spacing(2), ")"),
                xs: 1
              };
            },
            minWidth: 230,
            zIndex: function zIndex(t) {
              return t.zIndex._3;
            }
          },
          children: /*#__PURE__*/_jsx(ChallengeCard, {
            hideActions: true,
            replaceUrl: true,
            challenge: challenge,
            challengeLink: createChallengePlayerLink(location.pathname, {
              uuid: challenge.id
            })
          })
        }, challenge.id);
      }))
    }), hasMoreToShow && !showingMore ? /*#__PURE__*/_jsx(Button, {
      sx: {
        mt: 3
      },
      variant: "text",
      onClick: function onClick() {
        showMore();
        handleFetchMore();
      },
      children: t('See more')
    }) : null]
  });
};

export var PureRecommendedChallenges = function PureRecommendedChallenges(_ref2) {
  var challenges = _ref2.challenges,
      handleFetchMore = _ref2.handleFetchMore;
  return pipe(challenges, DE.squash(function () {
    return /*#__PURE__*/_jsx(Box, {
      sx: {
        display: 'flex',
        justifyContent: 'center'
      },
      children: /*#__PURE__*/_jsx(Box, {
        sx: {
          minWidth: 230
        },
        children: /*#__PURE__*/_jsx(LoadingChallengeCard, {})
      })
    });
  }, function (err, refreshing) {
    return /*#__PURE__*/_jsx(DisplayQueryError, {
      err: err,
      refreshing: refreshing,
      message: "Could not load suggested challenges"
    });
  }, function (_ref3) {
    var type = _ref3.type,
        challenges = _ref3.challenges;
    var showUnlocked = type === 'unlocked';
    return /*#__PURE__*/_jsx(RecommendedChallenges, {
      challenges: challenges,
      showUnlocked: showUnlocked,
      hasMoreToShow: showUnlocked && challenges.length > 3,
      handleFetchMore: handleFetchMore
    });
  }));
};
export default PureRecommendedChallenges;